"use client"

import { Form, Formik } from "formik"
import { FormSelect } from "@/components/form-inputs"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useTranslations } from "next-intl"


type AddDisclosureLanguageDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  languages: ReadonlyArray<{ value: string; label: string }>
  onAdd: (language: string) => void
}

export function AddDisclosureLanguageDialog({ open, onOpenChange, languages, onAdd }: AddDisclosureLanguageDialogProps) {
  const tUi = useTranslations("Organization.AddDisclosureLanguageDialog")
  const tCommonUi = useTranslations("Common")

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle><span key={tUi("addLanguage")}>{tUi("addLanguage")}</span></DialogTitle>
          <DialogDescription><span key={tUi("chooseALanguageThenEditAndSaveIts")}>{tUi("chooseALanguageThenEditAndSaveIts")}</span></DialogDescription>
        </DialogHeader>
        <Formik
          initialValues={{ language: languages[0]?.value ?? "" }}
          enableReinitialize
          onSubmit={async ({ language }) => {
            if (!languages.some(option => option.value === language)) return
            onAdd(language)
            onOpenChange(false)
          }}
        >
          {formik => (
            <Form className="space-y-4">
              <FormSelect
                name="language"
                label={tUi("language")}
                options={languages}
                placeholder={tUi("chooseALanguage")}
                separateOptions
                contentProps={{ side: "bottom", avoidCollisions: false }}
                contentClassName="max-h-[min(18rem,var(--radix-select-content-available-height))]"
              />
              <DialogFooter>
                <Button type="button" variant="outline" onClick={() => onOpenChange(false)}><span key={tCommonUi("cancel")}>{tCommonUi("cancel")}</span></Button>
                <Button type="submit" disabled={!formik.values.language || formik.isSubmitting}><span key={tUi("addLanguage")}>{tUi("addLanguage")}</span></Button>
              </DialogFooter>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
